import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { getBreadCrumbs, transformProperties } from "utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  heroBanner: () => import("../Common/Hero"),
  logoComponent: () => import("./Logo"),
  statistics: () => import("./Statistics"),
  tabsContent: () => import("./TabsContent"),
  buttonComponent: () => import("./Button"),
  anchorMenu: () => import("./AnchorMenu"),
  tabsContent1: () => import("./TabsWithAnchor"),
}

export default function EggedTransportation({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  // Filter only button blocks to determine which is the last one
  const buttonBlocks =
    blocks?.blocks?.filter(
      (block: any) => block.blockType === "buttonComponent",
    ) || []
  const anchorBlock =
    blocks?.blocks?.find((block: any) => block.blockType === "anchorMenu") ||
    null

  return (
    <>
      {blocks?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          // For button components, check if it's the last button
          let extraProps = {}
          if (block.blockType === "buttonComponent") {
            extraProps = {
              isLast: buttonBlocks[buttonBlocks.length - 1] === block,
            }
          }
          if (block.blockType === "tabsContent1") {
            extraProps = {
              anchorBlock,
            }
          }

          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              locale={locale}
              props={{ breadCrumbs, ...extraProps }}
            />
          )
        },
      )}
    </>
  )
}
